import OneSchemaImporter, { FileUploadImportConfig, LocalImportConfig } from '@oneschema/react';
import React from 'react';

import { env, isLocalEnvironment } from '@neo.tax/shared/utils';

type OneSchemaWrapperProps = {
  importConfig: FileUploadImportConfig | LocalImportConfig;
  isOpen: boolean;
  onCancel: () => void;
  onError: (error: unknown) => void;
  onLaunched?: () => void;
  onSuccess: () => Promise<void> | void;
  templateKey: string;
  userJwt: string;
};

export const OneSchemaWrapper = ({
  importConfig,
  isOpen,
  onCancel,
  onError,
  onLaunched,
  onSuccess,
  templateKey,
  userJwt,
}: OneSchemaWrapperProps): React.ReactElement => (
  <OneSchemaImporter
    /* managing state from your application */
    isOpen={isOpen}
    /* required config values */
    clientId={env.REACT_APP_ONE_SCHEMA_CLIENT_ID}
    userJwt={userJwt}
    templateKey={templateKey}
    /* optional config values */
    importConfig={importConfig}
    devMode={isLocalEnvironment()}
    className="oneschema-importer"
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 1000,
    }}
    /* handling results */
    onCancel={onCancel}
    onError={onError}
    onSuccess={onSuccess}
    onLaunched={onLaunched}
  />
);
